import React, { useState } from 'react';
import {
  FeedbackFloat,
  ModalContent,
  ModalTitleBox,
  Layer,
  ModalCloseButton,
} from '../../element';
import { useTranslation } from 'react-i18next';
import { Heading, Text } from 'grommet';
const Feedback = () => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);

  const handleFeedbackClick = () => {
    setShowModal(true);
  };
  const handleCloseModal = () => {
    setShowModal(false);
  };
  return (
    <>
      <FeedbackFloat
        data-test-id="feedback-float"
        onClick={handleFeedbackClick}
      >
        Feedback
      </FeedbackFloat>
      {showModal && (
        <Layer className="feedbackModal" dataTestId="feedback-modal">
          <ModalTitleBox
            direction="row"
            justify="between"
            align="center"
            pad={{ horizontal: 'large', top: 'small' }}
          >
            <Heading level={3}>{t('sendFeedback')}</Heading>
            <ModalCloseButton onClick={handleCloseModal}>
              <svg viewBox="0 0 24 24" width="16px" height="16px">
                <path
                  fill="none"
                  stroke="#444444"
                  strokeWidth="2"
                  d="m3 3 18 18M3 21 21 3"
                />
              </svg>
            </ModalCloseButton>
          </ModalTitleBox>
          <ModalContent
            pad={{ horizontal: 'large', bottom: 'large' }}
            gap="medium"
          >
            <Text>{t('sendFeedbackDesc')}</Text>
            <Text>
              {t('plsSendEmail')}
              <br />
              <a
                href="mailto:feedback.welcome.center@hpe.com"
                data-test-id="email-link"
              >
                feedback.welcome.center@hpe.com
              </a>
              .
            </Text>
            <Text>
              {t('reachTechnicalSupport')}
              <br />
              <a
                href="https://www.hpe.com/us/en/collaterals/collateral.a00039121enw.html"
                target="_blank"
                rel="noopener noreferrer"
              >
                Technical Support Phone Numbers
              </a>
              .
            </Text>
          </ModalContent>
        </Layer>
      )}
    </>
  );
};

export default Feedback;
